import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=0acd5fd3&scoped=true&"
import script from "./dataDictionary.vue?vue&type=script&lang=js&"
export * from "./dataDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd5fd3",
  null
  
)

export default component.exports